import {ENVIRONMENT_RIDDERRODE} from "./AppConstants.js";
import AppConfig from "./AppConfig.js";

// import DateTimeUtil from "../utils/DateTimeUtil";

class AppConfigRidderrode {

  static loadConfig = () => {
    AppConfig.sCurrentConfigDebugLabel = ENVIRONMENT_RIDDERRODE;
    AppConfig.aEntreeDagIDEALKortingExternalID = 854;
    AppConfig.aEntreeAvondExternalIDs = [5];
    // AppConfig.iDefaultOpeningTime = 1200;
    // AppConfig.iDefaultOpeningTimeSauna = 1200;
    // AppConfig.iDefaultOpeningTimeNonSauna = 1200;

    AppConfig.iNrOfActieArrangementCatThatShouldBeHidden = 7;

    AppConfig.aDatesWithAlternativeTimes = [ // wordt in de kalender lichtbruin weergegeven

    ];

    AppConfig.sTextTimeNormalEntreeFirstArrival = '12:00';
    AppConfig.sTextTimeNormalEntreeLastDeparture = '22:00';
    AppConfig.sTextTimeAvondEntreeFirstArrival = '17:00';

    AppConfig.aTimeConfig = {
      day0: { // ZONDAG
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day1: { // MAANDAG
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day2: { // DINSDAG
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day3: { // WOENSDAG
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day4: { // DONDERDAG
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day5: { // VRIJDAG
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      day6: { // ZATERDAG
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      daySpecial1: { // Kerstavond (24 DEC)
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1930, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 2200 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      },
      daySpecial2: { // Oudejaarsavond (31 DEC)
        iDefaultOpeningTimeSauna: 1200, // tijd waarop standaard de deuren open gaan
        iDefaultOpeningTimeNonSauna: 1200, // niet meer in gebruik
        iFirstEntryTimeEveningEntry: 1700, // tijd waarop standaard de deuren open gaan

        iDefaultLastEntryTime: 1700, // tijd waarop standaard de deuren sluiten
        iDefaultLastEntryTimeNonSauna: 1700, // niet meer in gebruik

        // NAAR BUITEN GAAN
        iDefaultClosingTimeNonSauna: 1800, // niet meer in gebruik
        iDefaultClosingTime: 1800 // tijd waarop standaard de laatste gasten eigenlijk weg moeten zijn
      }
    };
  };

  static aAlternateProductPricesRidderrode = [
    { // Ridderrode dag entree
      iID: 99999,
      aRules: [
        {
          iPrice: 4450,
          sDate: 'weekend'
        },
        // Herfst
        {
          iPrice: 4450,
          sDate: '28-10-2024'
        }
      ]
    }
  ];
}

export default AppConfigRidderrode;